import { Component, OnInit,AfterViewInit,HostBinding } from '@angular/core';
declare var $:any;
@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.css']
})
export class TestComponent implements OnInit,AfterViewInit {

  @HostBinding('style.width') public width: string = '100%';

  constructor() { }

  ngOnInit() {

  }


  ngAfterViewInit(){


    $(document).ready( function(){
		
        function getBase64(file) {
            return new Promise( function(resolve, reject){
              const reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = function(){ resolve(reader.result) };
              reader.onerror = function(error) { reject(error) };
            });
          }
    
    
         $("#fileInput").change(function(e){
        
        
         getBase64(e.target.files[0]).then(
        
            function(data){
          
       
        
              $('#contain').resizeImage({
                                    image: data,
                                    // imgFormat: 'auto', // Formats: 3/2, 200x360, auto
                                    // circleCrop: true,
                                    // zoomable: true,
                                    // outBoundColor: 'white', // black, white
                                    btnDoneAttr: '.resize-done',
                                    width:'304',
                                    height:'304'
                                    
                                  }, function( imgResized ){
                                    
                                    $('#move-stats').html( '<h3>Resized Image</h3><img style="margin:10% auto;" src="'+ imgResized +'">' )
                                  } )
            
            
                  
            }
          );
        });
      
      
        
         
      } )

  }

}
